/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "Kritzel",
  "tagline": "Kritzel helps you build infinite canvas experiences featuring real-time collaboration and high-performance drawing tools. Fully open-source and easy to integrate into React, Vue & Angular.",
  "favicon": "img/favicon.svg",
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": true,
      "useCssCascadeLayers": true,
      "siteStorageNamespacing": true,
      "fasterByDefault": true,
      "mdx1CompatDisabledByDefault": true
    },
    "faster": {
      "rspackBundler": true,
      "rspackPersistentCache": true,
      "swcJsLoader": true,
      "swcJsMinimizer": true,
      "swcHtmlMinimizer": true,
      "lightningCssMinimizer": true,
      "mdxCrossCompilerCache": true,
      "ssgWorkerThreads": true,
      "gitEagerVcs": true
    },
    "experimental_vcs": {},
    "experimental_router": "browser"
  },
  "url": "https://kritzel.io",
  "baseUrl": "/",
  "trailingSlash": true,
  "organizationName": "kasual1",
  "projectName": "kritzel",
  "onBrokenLinks": "warn",
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en"
    ],
    "path": "i18n",
    "localeConfigs": {}
  },
  "markdown": {
    "mermaid": true,
    "hooks": {
      "onBrokenMarkdownLinks": "warn",
      "onBrokenMarkdownImages": "throw"
    },
    "format": "mdx",
    "emoji": true,
    "mdx1Compat": {
      "comments": false,
      "admonitions": false,
      "headingIds": false
    },
    "anchors": {
      "maintainCase": false
    }
  },
  "customFields": {
    "demoBaseUrls": {
      "angular": "https://kasual1.github.io/kritzel/angular",
      "react": "https://kasual1.github.io/kritzel/react",
      "vue": "https://kasual1.github.io/kritzel/vue"
    }
  },
  "clientModules": [
    "/home/runner/work/kritzel/kritzel/apps/website/src/clientModules/pageTransition.ts"
  ],
  "themes": [
    "@docusaurus/theme-mermaid"
  ],
  "presets": [
    [
      "classic",
      {
        "docs": false,
        "blog": {
          "showReadingTime": true,
          "blogSidebarTitle": "All posts",
          "routeBasePath": "blog"
        },
        "sitemap": {
          "changefreq": "weekly",
          "priority": 0.5,
          "filename": "sitemap.xml"
        },
        "theme": {
          "customCss": [
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/theming.css",
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/typography.css",
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/header.css",
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/navbar.css",
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/hero.css",
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/buttons.css",
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/general.css",
            "/home/runner/work/kritzel/kritzel/apps/website/src/css/footer.css"
          ]
        }
      }
    ]
  ],
  "plugins": [
    [
      "docusaurus-plugin-llms",
      {
        "title": "Kritzel",
        "description": "The infinite canvas development kit for Angular, React, and Vue.",
        "docsDir": [
          {
            "path": "docs/angular",
            "routeBasePath": "docs/angular",
            "label": "Angular"
          },
          {
            "path": "docs/react",
            "routeBasePath": "docs/react",
            "label": "React"
          },
          {
            "path": "docs/vue",
            "routeBasePath": "docs/vue",
            "label": "Vue"
          }
        ],
        "generateLLMsTxt": true,
        "generateLLMsFullTxt": false,
        "generateMarkdownFiles": true,
        "preserveDirectoryStructure": true,
        "addMdExtension": true,
        "useRelativeUrls": false,
        "includeBlog": false,
        "excludeImports": true,
        "preserveComponents": [
          "LiveDemo"
        ],
        "removeDuplicateHeadings": false,
        "rewriteImageUrls": true,
        "keepFrontMatter": [],
        "includeOrder": [
          "**/getting-started/quick-start.md",
          "**/getting-started/basic-usage.md",
          "**/fundamentals/**",
          "**/api-reference/**",
          "**/customization/**",
          "**/advanced/**",
          "**/examples/**"
        ],
        "includeUnmatchedLast": true,
        "logLevel": "normal",
        "rootContent": "Choose the application's framework first and read only the matching setup and API references. Do not mix Angular, React, and Vue wrappers.\n\n- Use @kritzel/angular-editor, @kritzel/react-editor, or @kritzel/vue-editor for the complete editor UI. Use the matching engine wrapper for a bare canvas and custom UI; the engine registers no tools by default.\n\n- Give the canvas host an explicit width and height. Wait for the editor's isReady or the engine's isEngineReady event before calling methods, and await asynchronous methods.\n\n- Check the installed package version and prefer its TypeScript types when they differ from these current documentation pages.\n\n- Persistence is opt-in through syncConfig. Use a distinct editorId for each instance when multiple canvases can exist.\n\n- Use addObject/addObjects to insert objects and updateObject to change them. Object positions use world coordinates; use screenToWorld to convert pointer coordinates.\n\n- For a reusable coding-agent integration workflow, install the Kritzel skill with `npx skills add kasual1/kritzel`.\n\nLiveDemo tags are source metadata, not instructions to execute JSX: repoUrl identifies the public framework demo directory, repoFiles lists source files relative to it, and demoPath identifies the runnable example route. For a source file, replace /tree/ with /blob/ in repoUrl and append its repoFiles path. Runnable demos are hosted at https://kasual1.github.io/kritzel/{framework}{demoPath}.\n\nStart with the matching framework's Quick Start and Basic Usage, then follow the focused API or concept pages below. The linked Markdown pages are generated from the same sources as the human documentation."
      }
    ],
    null,
    null,
    null,
    [
      "@docusaurus/plugin-client-redirects",
      {
        "redirects": [
          {
            "from": "/docs/angular/quick-start",
            "to": "/docs/angular/getting-started/quick-start"
          },
          {
            "from": "/docs/angular/basic-usage",
            "to": "/docs/angular/getting-started/basic-usage"
          },
          {
            "from": "/docs/angular/concept-tools",
            "to": "/docs/angular/fundamentals/tools"
          },
          {
            "from": "/docs/angular/concept-objects",
            "to": "/docs/angular/fundamentals/objects"
          },
          {
            "from": "/docs/angular/concept-viewport",
            "to": "/docs/angular/fundamentals/viewport"
          },
          {
            "from": "/docs/angular/concept-workspaces",
            "to": "/docs/angular/fundamentals/workspaces"
          },
          {
            "from": "/docs/angular/concept-persistence",
            "to": "/docs/angular/fundamentals/persistence"
          },
          {
            "from": "/docs/angular/advanced/concept-collaboration",
            "to": "/docs/angular/advanced/collaboration"
          },
          {
            "from": "/docs/angular/advanced/concept-dynamic-objects",
            "to": "/docs/angular/advanced/dynamic-objects"
          },
          {
            "from": "/docs/angular/advanced/concept-user-management",
            "to": "/docs/angular/advanced/user-management"
          },
          {
            "from": "/docs/angular/advanced/customization/concept-theming",
            "to": "/docs/angular/customization/themes"
          },
          {
            "from": "/docs/angular/advanced/customization/concept-fonts",
            "to": "/docs/angular/customization/fonts"
          },
          {
            "from": "/docs/angular/advanced/customization/concept-icons",
            "to": "/docs/angular/customization/icons"
          },
          {
            "from": "/docs/angular/advanced/customization/concept-localization",
            "to": "/docs/angular/customization/locales"
          },
          {
            "from": "/docs/angular/customization/titlebars",
            "to": "/docs/angular/fundamentals/controls"
          },
          {
            "from": "/docs/angular/customization/object-config",
            "to": "/docs/angular/fundamentals/objects"
          },
          {
            "from": "/docs/angular/example-object-explorer",
            "to": "/docs/angular/examples/object-explorer"
          },
          {
            "from": "/docs/angular/example-blueprint-defect-mapper",
            "to": "/docs/angular/examples/blueprint-defect-mapper"
          },
          {
            "from": "/docs/angular/example-slideshow-presentation",
            "to": "/docs/angular/examples/slideshow-presentation"
          },
          {
            "from": "/docs/angular/example-image-annotation-studio",
            "to": "/docs/angular/examples/image-annotation-studio"
          },
          {
            "from": "/docs/angular/api-reference-editor",
            "to": "/docs/angular/api-reference/editor"
          },
          {
            "from": "/docs/angular/api-reference-engine",
            "to": "/docs/angular/api-reference/engine"
          },
          {
            "from": "/docs/angular/objects",
            "to": "/docs/angular/api-reference/objects"
          },
          {
            "from": "/docs/react/quick-start",
            "to": "/docs/react/getting-started/quick-start"
          },
          {
            "from": "/docs/react/basic-usage",
            "to": "/docs/react/getting-started/basic-usage"
          },
          {
            "from": "/docs/react/concept-tools",
            "to": "/docs/react/fundamentals/tools"
          },
          {
            "from": "/docs/react/concept-objects",
            "to": "/docs/react/fundamentals/objects"
          },
          {
            "from": "/docs/react/concept-viewport",
            "to": "/docs/react/fundamentals/viewport"
          },
          {
            "from": "/docs/react/concept-workspaces",
            "to": "/docs/react/fundamentals/workspaces"
          },
          {
            "from": "/docs/react/concept-persistence",
            "to": "/docs/react/fundamentals/persistence"
          },
          {
            "from": "/docs/react/advanced/concept-collaboration",
            "to": "/docs/react/advanced/collaboration"
          },
          {
            "from": "/docs/react/advanced/concept-dynamic-objects",
            "to": "/docs/react/advanced/dynamic-objects"
          },
          {
            "from": "/docs/react/advanced/concept-user-management",
            "to": "/docs/react/advanced/user-management"
          },
          {
            "from": "/docs/react/advanced/customization/concept-theming",
            "to": "/docs/react/customization/themes"
          },
          {
            "from": "/docs/react/advanced/customization/concept-fonts",
            "to": "/docs/react/customization/fonts"
          },
          {
            "from": "/docs/react/advanced/customization/concept-icons",
            "to": "/docs/react/customization/icons"
          },
          {
            "from": "/docs/react/advanced/customization/concept-localization",
            "to": "/docs/react/customization/locales"
          },
          {
            "from": "/docs/react/customization/titlebars",
            "to": "/docs/react/fundamentals/controls"
          },
          {
            "from": "/docs/react/customization/object-config",
            "to": "/docs/react/fundamentals/objects"
          },
          {
            "from": "/docs/react/example-object-explorer",
            "to": "/docs/react/examples/object-explorer"
          },
          {
            "from": "/docs/react/example-blueprint-defect-mapper",
            "to": "/docs/react/examples/blueprint-defect-mapper"
          },
          {
            "from": "/docs/react/example-slideshow-presentation",
            "to": "/docs/react/examples/slideshow-presentation"
          },
          {
            "from": "/docs/react/example-image-annotation-studio",
            "to": "/docs/react/examples/image-annotation-studio"
          },
          {
            "from": "/docs/react/api-reference-editor",
            "to": "/docs/react/api-reference/editor"
          },
          {
            "from": "/docs/react/api-reference-engine",
            "to": "/docs/react/api-reference/engine"
          },
          {
            "from": "/docs/react/objects",
            "to": "/docs/react/api-reference/objects"
          },
          {
            "from": "/docs/react/theming",
            "to": "/docs/react/api-reference/theme-tokens"
          },
          {
            "from": "/docs/react/types",
            "to": "/docs/react/api-reference/types"
          },
          {
            "from": "/docs/vue/quick-start",
            "to": "/docs/vue/getting-started/quick-start"
          },
          {
            "from": "/docs/vue/basic-usage",
            "to": "/docs/vue/getting-started/basic-usage"
          },
          {
            "from": "/docs/vue/concept-tools",
            "to": "/docs/vue/fundamentals/tools"
          },
          {
            "from": "/docs/vue/concept-objects",
            "to": "/docs/vue/fundamentals/objects"
          },
          {
            "from": "/docs/vue/concept-viewport",
            "to": "/docs/vue/fundamentals/viewport"
          },
          {
            "from": "/docs/vue/concept-workspaces",
            "to": "/docs/vue/fundamentals/workspaces"
          },
          {
            "from": "/docs/vue/concept-persistence",
            "to": "/docs/vue/fundamentals/persistence"
          },
          {
            "from": "/docs/vue/advanced/concept-collaboration",
            "to": "/docs/vue/advanced/collaboration"
          },
          {
            "from": "/docs/vue/advanced/concept-dynamic-objects",
            "to": "/docs/vue/advanced/dynamic-objects"
          },
          {
            "from": "/docs/vue/advanced/concept-user-management",
            "to": "/docs/vue/advanced/user-management"
          },
          {
            "from": "/docs/vue/advanced/customization/concept-theming",
            "to": "/docs/vue/customization/themes"
          },
          {
            "from": "/docs/vue/advanced/customization/concept-fonts",
            "to": "/docs/vue/customization/fonts"
          },
          {
            "from": "/docs/vue/advanced/customization/concept-icons",
            "to": "/docs/vue/customization/icons"
          },
          {
            "from": "/docs/vue/advanced/customization/concept-localization",
            "to": "/docs/vue/customization/locales"
          },
          {
            "from": "/docs/vue/customization/titlebars",
            "to": "/docs/vue/fundamentals/controls"
          },
          {
            "from": "/docs/vue/customization/object-config",
            "to": "/docs/vue/fundamentals/objects"
          },
          {
            "from": "/docs/vue/example-object-explorer",
            "to": "/docs/vue/examples/object-explorer"
          },
          {
            "from": "/docs/vue/example-blueprint-defect-mapper",
            "to": "/docs/vue/examples/blueprint-defect-mapper"
          },
          {
            "from": "/docs/vue/example-slideshow-presentation",
            "to": "/docs/vue/examples/slideshow-presentation"
          },
          {
            "from": "/docs/vue/example-image-annotation-studio",
            "to": "/docs/vue/examples/image-annotation-studio"
          },
          {
            "from": "/docs/vue/api-reference-editor",
            "to": "/docs/vue/api-reference/editor"
          },
          {
            "from": "/docs/vue/api-reference-engine",
            "to": "/docs/vue/api-reference/engine"
          },
          {
            "from": "/docs/vue/objects",
            "to": "/docs/vue/api-reference/objects"
          },
          {
            "from": "/docs/vue/types",
            "to": "/docs/vue/api-reference/types"
          }
        ]
      }
    ],
    [
      "@docusaurus/plugin-content-docs",
      {
        "id": "angular",
        "path": "docs/angular",
        "routeBasePath": "docs/angular",
        "sidebarPath": "./sidebars.ts",
        "breadcrumbs": true
      }
    ],
    [
      "@docusaurus/plugin-content-docs",
      {
        "id": "react",
        "path": "docs/react",
        "routeBasePath": "docs/react",
        "sidebarPath": "./sidebars.ts",
        "breadcrumbs": true
      }
    ],
    [
      "@docusaurus/plugin-content-docs",
      {
        "id": "vue",
        "path": "docs/vue",
        "routeBasePath": "docs/vue",
        "sidebarPath": "./sidebars.ts",
        "breadcrumbs": true
      }
    ]
  ],
  "themeConfig": {
    "blog": {
      "sidebar": {
        "groupByYear": false
      }
    },
    "image": "img/docusaurus-social-card.jpg",
    "navbar": {
      "title": "Kritzel",
      "logo": {
        "alt": "Kritzel Infinite Canvas",
        "src": "img/logo.svg",
        "width": 24,
        "height": 24
      },
      "items": [
        {
          "type": "custom-blogLink",
          "label": "Blog",
          "position": "right"
        },
        {
          "type": "custom-docsLink",
          "label": "Documentation",
          "to": "/docs/react/getting-started/quick-start",
          "position": "right"
        },
        {
          "type": "custom-docsLink",
          "label": "Get Started",
          "to": "/docs/react/getting-started/quick-start",
          "position": "right",
          "className": "navbar-get-started-link"
        },
        {
          "type": "dropdown",
          "position": "right",
          "label": "Angular",
          "items": [
            {
              "label": "React",
              "to": "/docs/react/getting-started/quick-start",
              "activeBasePath": "docs/react"
            },
            {
              "label": "Vue",
              "to": "/docs/vue/getting-started/quick-start",
              "activeBasePath": "docs/vue"
            },
            {
              "label": "Angular",
              "to": "/docs/angular/getting-started/quick-start",
              "activeBasePath": "docs/angular"
            }
          ]
        },
        {
          "label": "GitHub",
          "href": "https://github.com/kasual1/kritzel",
          "position": "right",
          "className": "navbar-main-github-link"
        }
      ],
      "hideOnScroll": false
    },
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": true,
      "respectPrefersColorScheme": false
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "footer": {
      "style": "light",
      "links": [
        {
          "title": "Documentation",
          "items": [
            {
              "label": "Getting Started",
              "to": "/docs/react/getting-started/quick-start"
            },
            {
              "label": "Examples",
              "to": "/docs/react/examples/object-explorer"
            }
          ]
        },
        {
          "title": "Frameworks",
          "items": [
            {
              "label": "Angular",
              "to": "/docs/angular/getting-started/quick-start"
            },
            {
              "label": "React",
              "to": "/docs/react/getting-started/quick-start"
            },
            {
              "label": "Vue",
              "to": "/docs/vue/getting-started/quick-start"
            }
          ]
        },
        {
          "title": "Community",
          "items": [
            {
              "html": "<a href=\"https://x.com/kritzel_io\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"footer__link-item\">X</a>"
            },
            {
              "html": "<a href=\"https://linkedin.com/in/kritzel-app-26721b40b\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"footer__link-item\">LinkedIn</a>"
            },
            {
              "html": "<a href=\"https://bsky.app/profile/kritzelio.bsky.social\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"footer__link-item\">Bluesky</a>"
            },
            {
              "html": "<a href=\"https://github.com/kasual1/kritzel\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"footer__link-item\">GitHub</a>"
            },
            {
              "html": "<a href=\"https://www.npmjs.com/package/@kritzel/engine\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"footer__link-item\">NPM</a>"
            }
          ]
        }
      ],
      "copyright": "<span class=\"footer__meta\"><span class=\"footer__meta-item\">Copyright © 2026 Kritzel</span></span>"
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    },
    "mermaid": {
      "theme": {
        "dark": "dark",
        "light": "default"
      },
      "options": {}
    }
  },
  "headTags": [
    {
      "tagName": "link",
      "attributes": {
        "rel": "describedby",
        "href": "https://kritzel.io/llms.txt"
      },
      "customElement": false
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "apple-touch-icon",
        "sizes": "512x512",
        "href": "/img/logo_avatar.png"
      },
      "customElement": false
    },
    {
      "tagName": "script",
      "attributes": {
        "defer": true,
        "src": "https://cloud.umami.is/script.js",
        "data-website-id": "f5a72d39-5ee9-4d3d-852c-a0dc99199d9e"
      },
      "customElement": false
    },
    {
      "tagName": "script",
      "attributes": {
        "type": "application/ld+json"
      },
      "innerHTML": "{\"@context\":\"https://schema.org\",\"@type\":\"WebSite\",\"name\":\"Kritzel\",\"alternateName\":\"Kritzel Infinite Canvas Library\",\"url\":\"https://kritzel.io/\",\"description\":\"Kritzel is a framework-agnostic infinite canvas and collaborative whiteboard library for Angular, React, and Vue.\"}",
      "customElement": false
    },
    {
      "tagName": "script",
      "attributes": {
        "type": "application/ld+json"
      },
      "innerHTML": "{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"name\":\"Kritzel\",\"url\":\"https://kritzel.io/\",\"logo\":\"https://kritzel.io/img/logo.svg\",\"sameAs\":[\"https://github.com/kasual1/kritzel\"]}",
      "customElement": false
    },
    {
      "tagName": "script",
      "attributes": {
        "type": "application/ld+json"
      },
      "innerHTML": "{\"@context\":\"https://schema.org\",\"@type\":\"ItemList\",\"itemListElement\":[{\"@type\":\"SiteNavigationElement\",\"position\":1,\"name\":\"Documentation\",\"description\":\"Guides, concepts, and API reference for the Kritzel infinite canvas library.\",\"url\":\"https://kritzel.io/docs/react/getting-started/quick-start\"},{\"@type\":\"SiteNavigationElement\",\"position\":2,\"name\":\"Getting Started\",\"description\":\"Quick start guide to install and integrate Kritzel into your app.\",\"url\":\"https://kritzel.io/docs/react/getting-started/quick-start\"},{\"@type\":\"SiteNavigationElement\",\"position\":3,\"name\":\"API Reference\",\"description\":\"Detailed reference for the Kritzel editor and engine components.\",\"url\":\"https://kritzel.io/docs/react/api-reference/editor\"},{\"@type\":\"SiteNavigationElement\",\"position\":4,\"name\":\"Angular\",\"description\":\"Use Kritzel in Angular applications.\",\"url\":\"https://kritzel.io/docs/angular/getting-started/quick-start\"},{\"@type\":\"SiteNavigationElement\",\"position\":5,\"name\":\"React\",\"description\":\"Use Kritzel in React applications.\",\"url\":\"https://kritzel.io/docs/react/getting-started/quick-start\"},{\"@type\":\"SiteNavigationElement\",\"position\":6,\"name\":\"Vue\",\"description\":\"Use Kritzel in Vue applications.\",\"url\":\"https://kritzel.io/docs/vue/getting-started/quick-start\"}]}",
      "customElement": false
    }
  ],
  "baseUrlIssueBanner": true,
  "storage": {
    "type": "localStorage",
    "namespace": true
  },
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "scripts": [],
  "stylesheets": [],
  "titleDelimiter": "|",
  "noIndex": false
};
